import { MouseEvent } from "react";
import { format } from "date-fns";

import { MileageModel } from "@interfaces/index";
import { formatAmount } from "@utils/index";
import { PencilSvg, TrashSvg } from "@components/index";

export const TableTdDesktopMileage = ({
  mileage,
  isDiBusiness,
  onClickRow,
  onEdit,
  onRemove,
}: {
  mileage: MileageModel;
  isDiBusiness: boolean;
  onClickRow?: () => void;
  onEdit?: () => void;
  onRemove?: () => void;
}) => {
  const handleEdit = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (onEdit) {
      onEdit();
    }
  };

  const handleRemove = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (onRemove) {
      onRemove();
    }
  };

  return (
    <tr
      className="group cursor-pointer border-b border-b-black-8 last:border-b-0 hover:bg-black-4"
      data-testid="tr_mileageTable"
      onClick={onClickRow}
    >
      <td className="py-4 text-black-100">
        {format(new Date(mileage.dateFrom), "dd.MM.yy")} -{" "}
        {format(new Date(mileage.dateTo), "dd.MM.yy")}
      </td>
      <td className="py-4 capitalize text-black-54">{mileage.period.title}</td>
      <td className="max-w-36 truncate py-6">{mileage.asset.name}</td>
      <td className="py-4 text-black-100">{mileage.businessMiles} miles</td>
      {isDiBusiness && (
        <td className="py-4 text-black-100">{mileage.privateMiles} miles</td>
      )}
      <td className="py-4 text-black-100">{mileage.totalMiles} miles</td>
      <td className="py-4 text-black-100">
        {isDiBusiness
          ? `${mileage.privateUse}%`
          : `£${formatAmount(mileage.mileageSum)}`}
      </td>
      <td className="pr-4">
        {(mileage.policies.canDelete || mileage.policies.canUpdate) && (
          <div className="hidden justify-end gap-x-2 text-black-54 group-hover:flex">
            {mileage.policies.canUpdate && (
              <button type="button" onClick={handleEdit}>
                <PencilSvg />
              </button>
            )}
            {mileage.policies.canDelete && mileage.policies.canUpdate && (
              <div className="h-6 w-px bg-black-16" />
            )}
            {mileage.policies.canDelete && (
              <button type="button" onClick={handleRemove}>
                <TrashSvg />
              </button>
            )}
          </div>
        )}
      </td>
    </tr>
  );
};
